export const generateProjectsCSVData = async (
  projectsData,
  projectGroups,
  companyData
) => {
  if (!projectsData || projectsData.length === 0) return "";

  const fields = [
    "ID",
    "Project Name",
    "Project Group",
    "Client",
    "Lead",
    "Created (mm/dd/yyyy)",
    "State",
    "Source",
    "Start (mm/dd/yyyy)",
    "Closed (mm/dd/yyyy)",
    "Forecasted Service Revenue",
    "Hours (act/est)",
    "Estimated Service Value",
    "Material Value",
    "Total Value",
    "Actual Service Value",
    "Total Cost",
    "Invoiced Service Value",
  ];

  const csvData = projectsData.map((row) => {
    const getSourceLabel = (value) => {
      const sourceOptions = [
        { label: "RFP", value: "rfp" },
        { label: "New Lead", value: "newLead" },
        { label: "New Work", value: "newWork" },
      ];
      return (
        sourceOptions.find((opt) => opt.value === value)?.label || value || ""
      );
    };

    const formatNumber = (num) => {
      if (isNaN(num)) return "0.00";
      return Number(num).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const escapeCSVField = (value) => {
      if (value == null) return "";
      const str = String(value);
      if (str.includes(",") || str.includes('"') || str.includes("\n")) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const projectGroup =
      projectGroups?.[String(row.addToExistingProject)]?.projectName || "";

    const companyName = companyData?.[row.client] || row.client || "";

    const serviceValue = `$ ${row.serviceValue}`;

    const expenseHours = row.financials?.expense?.hours || 0;
    const budgetedHours = row.financials?.budget?.hours || 0;
    const hoursDisplay = `${formatNumber(expenseHours)} hrs / ${formatNumber(
      budgetedHours
    )} hrs`;

    const plannerServiceValue = `$ ${formatNumber(
      row.plannerServiceValue || 0
    )}`;

    const materialsBudget =
      row.materials?.reduce(
        (sum, mat) => sum + parseFloat(mat.total || 0),
        0
      ) || 0;
    const materialValue = `$ ${formatNumber(materialsBudget)}`;

    const totalValue = `$ ${formatNumber(row.projectTotal || 0)}`;

    const actualServiceValue = `$ ${formatNumber(
      row.financials?.expense?.cost || 0
    )}`;

    const totalCost = `$ ${formatNumber(
      row.financials?.expense?.actualExpense || 0
    )}`;

    const finalInvoicedServiceValue = (() => {
      const value = row.invoiceValue;
      if (!value || Number(value) === 0) return "$ 0.00";
      if (Number(value)) return `$ ${formatNumber(value)}`;
      return value;
    })();

    return [
      escapeCSVField(row.firestoreId),
      escapeCSVField(row.projectName),
      escapeCSVField(projectGroup),
      escapeCSVField(companyName),
      escapeCSVField(row.projectLead),
      escapeCSVField(row.dateCreated),
      escapeCSVField(row.state),
      escapeCSVField(getSourceLabel(row.source)),
      escapeCSVField(row.start || "N/A"),
      escapeCSVField(row.end || "N/A"),
      escapeCSVField(serviceValue),
      escapeCSVField(hoursDisplay),
      escapeCSVField(plannerServiceValue),
      escapeCSVField(materialValue),
      escapeCSVField(totalValue),
      escapeCSVField(actualServiceValue),
      escapeCSVField(totalCost),
      escapeCSVField(finalInvoicedServiceValue),
    ].join(",");
  });

  return [fields.join(","), ...csvData].join("\n");
};
